import { directorApi } from '../director/directorApi'

// «Оқушылар санын тексеру»: /api/student-reconcile/*. Поля = studentReconcile.proto, 0 / "" -> null в bff.

export type RcSeverity = 'ERROR' | 'WARN' | 'INFO'

export interface RcOption {
    courseId: number
    courseTitleKz: string | null
    courseTitleRu: string | null
    subjectId: number
    subjectTitleKz: string | null
    subjectTitleRu: string | null
}

export interface RcCount {
    category: string
    severity: RcSeverity
    rows: number
    students: number
    truncated: boolean
}

export interface RcIssue {
    category: string
    severity: RcSeverity
    userId: number | null
    userCourseEnrollId: number | null
    userSubjectEnrollId: number | null
    intakeId: number | null
    name: string | null
    phone: string | null
    courseId: number | null
    courseTitleKz: string | null
    courseTitleRu: string | null
    subjectId: number | null
    subjectTitleKz: string | null
    subjectTitleRu: string | null
    groupTitle: string | null
    crmStatus: string | null
    date: string | null
}

export interface RcCrm {
    platformStudents: number
    crmApproved: number
    phoneVisible: boolean
    counts: RcCount[]
    issues: RcIssue[]
}

export interface RcGroupRow {
    groupId: number
    groupTitle: string | null
    curatorList: number
    rating: number
    salary: number
    differs: boolean
}

export interface RcMentorRow {
    mentorId: number
    mentorName: string
    curatorList: number
    rating: number
    salary: number
    salaryList: number
    director: number
    differs: boolean
    groups: RcGroupRow[]
}

export interface RcMentors {
    differCount: number
    mentors: RcMentorRow[]
}

export interface RcFilter {
    courseId: number
    subjectId: number
}

export const reconcileApi = directorApi.injectEndpoints({
    endpoints: (build) => ({
        getReconcileOptions: build.query<RcOption[], void>({
            // subjectId: 0 - чтобы фильтр «Пән» директора не сузил сам список вариантов
            query: () => ({ url: 'student-reconcile/options', params: { subjectId: 0 } }),
            transformResponse: (r: { data: RcOption[] }) => r.data,
        }),
        getCrmReconcile: build.query<RcCrm, RcFilter>({
            query: (params) => ({ url: 'student-reconcile/crm', params }),
            transformResponse: (r: { data: RcCrm }) => r.data,
        }),
        getMentorReconcile: build.query<RcMentors, RcFilter>({
            query: (params) => ({ url: 'student-reconcile/mentors', params }),
            transformResponse: (r: { data: RcMentors }) => r.data,
        }),
    }),
})
